<template>
    <div>
        <app-loader v-if="isLoading && !isAutoSsoLogin"></app-loader>
        <LoginFrame :isMobileSso=isMobileSso>
            <!-- Auto SSO Login in progress -->
            <div v-if="isAutoSsoLogin && isLoading" class="login-form-container">
                <h1 style="font-weight: 600">Signing in...</h1>
                <br />
                <p v-if="autoSsoEmail">Logging in as {{ autoSsoEmail }}</p>
                <p v-else>Using your Microsoft account</p>
                <br />
                <a href="#" @click.prevent="useDifferentAccount">Use a different account</a>
            </div>
            <!-- Normal login form -->
            <div v-show="!isLoading && !isAutoSsoLogin" class="login-form-container">
                <h1 style="font-weight: 600">{{ titleText }}</h1>
                <br />
                <div>
                    <app-text-field id="username" name="username" v-model="email" type="email" label="Email" class="login-input" :disabled="!isPreLoginShowing" @onKeypressEnter="onEnter"/>
                    <app-text-field id="password" name="password" v-model="password" type="password" label="Password" class="mt-3 login-input" v-if="isPasswordShowing" @onKeypressEnter="onEnter"/>
                    <a v-if="showOAuthLoginLink && !isPasswordShowing" href="#" @click="loginWithSso">Log in with SSO</a>
                    <a v-else-if="showSamlLoginLink && !isPasswordShowing" href="#" @click="loginWithSaml">Log in with SSO</a>
                    <br/>
                    <a v-if="isPasswordOptionShowing" href="#" @click="showPasswordLogin">Log in with Sway password</a>
                </div>
                <v-btn
                        color="primary"
                        style="width: 100%"
                        class="mt-3"
                        @click="onSubmit"
                        :loading="loading"
                        v-if="isPreLoginShowing || isPasswordShowing"
                >Submit</v-btn>
                <div style="margin-top: 20px; color: var(--v-text-lighten2)" class="hover" @click="forgotPassword" v-if="isPasswordShowing">
                    Forgot Password
                </div>
                <div style="margin-top: 20px; color: var(--v-text-lighten2)" class="hover" @click="backToPreLogin" v-if="showOAuthLoginLink || showSamlLoginLink || isPasswordShowing">
                    Login With Different Email
                </div>

            </div>
        </LoginFrame>
        <v-overlay
            :model-value="mfaVerificationDialog"
            class="align-center justify-center"
            persistent
        >
            <v-card v-if="mfaVerificationDialog" width="500">
                <MfaDialog
                        :account="account"
                        @setAccount="setAccount"
                        @finishLogin="finishLogin">
                </MfaDialog>
            </v-card>
        </v-overlay>
    </div>


</template>

<script>

import semver from "semver";

let viewport = document.querySelector("meta[name=viewport]");
viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');

import funcs from "@/js/funcs";
import httpService from "@/services/httpService";
import {auth, loginRequest, tokenConfig} from "@/main";
import {baseUrl} from "@/config"
import {isMobileBrowser} from "@/js/utilities";
import LoginFrame from "@/components/Login/LoginFrame.vue";
import MfaDialog from "@/components/Login/MfaDialog.vue";
import {
    login,
    ssologin,
    switchSelectedOrganization,
    samllogin, getloginmethod,
    initializePendo
} from "@/services/userService";
export default {
    name: "Login",
    components: {MfaDialog, LoginFrame},
    props: {
        account: {}
    },
    data() {
        return {
            titleText: 'Login',
            email: '',
            password: '',
            failedLogin: false,
            loading: false,
            mfaVerificationDialog: false,

            ssoAccount: null,
            ssoToken: null,

            isPreLoginShowing: true,
            showOAuthLoginLink: false,
            showSamlLoginLink: false,
            
            isPasswordOptionShowing: false,
            isPasswordShowing: false,
            isLoading: true,
            isMobileSso: false,
            mobileAppVersion: null,
            isCallback: false,
            isSamlLinkPressed: false,
            isAutoSsoLogin: false,
            autoSsoEmail: null,
            forceAccountSelect: false,
            allowSubmit: false
        }
    },
    beforeMount() {
        console.log('NewLogin beforeMount - URL:', window.location.href);
        console.log('NewLogin beforeMount - query:', this.$route.query);

        if (this.$route.query.mobileSso)
            this.isMobileSso = true;
        if (this.$route.query.mobileAppVersion)
            this.mobileAppVersion = this.$route.query.mobileAppVersion;
        if (this.$route.query.isCallback)
            this.isCallback = true;

        try{
            this.ssoAccount = auth.getAccount();
            console.log('NewLogin - ssoAccount:', this.ssoAccount);
            console.log('NewLogin - ssoToken:', this.ssoToken);
            console.log('NewLogin - isCallback:', this.isCallback);

            // If this is a callback from SSO redirect, process it
            if (this.isCallback && this.ssoAccount) {
                console.log('NewLogin - processing SSO callback');
                this.isLoading = true;
                this.getTokenSso(false).then((token) => {
                    if (token && token.accessToken) {
                        this.ssoToken = token.accessToken;
                        this.extraLoginOauth();
                    } else {
                        this.isLoading = false;
                    }
                });
            } else if (this.ssoAccount) {
                // Not a callback - clear MSAL state to prevent auto-renewal redirects
                console.log('NewLogin - clearing MSAL cache to prevent auto-redirect');
                auth.clearCache();

                // Pre-fill email but don't auto-login
                this.autoSsoEmail = this.ssoAccount.userName || this.ssoAccount.username || this.ssoAccount.idTokenClaims?.preferred_username;
                this.email = this.autoSsoEmail || '';
                console.log('NewLogin - pre-filled email:', this.email);
                this.isLoading = false;
                this.ssoAccount = null;
            } else {
                this.isLoading = false;
            }
        }
        catch (ex){
            console.log('NewLogin - error:', ex);
            this.isLoading = false;
        }
        
        try{
            let email = this.$route.query.email;
            console.log('NewLogin - checking mobile SSO path, email:', email, 'isMobileSso:', this.isMobileSso, 'isCallback:', this.isCallback);
            if (email && this.isMobileSso && !this.isCallback){
                console.log('NewLogin - triggering mobile SSO auto-submit');
                this.email = email;
                this.allowSubmit = true;
                this.onSubmit();
                return;
            }
        }
        catch (ex){
            console.log('NewLogin - mobile SSO check error:', ex);
        }

        try{
            var samlCookie = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("portal_samljwt="))
                    ?.split("=")[1];
            console.log('NewLogin - checking SAML cookie:', !!samlCookie);
            if (samlCookie)
            {
                if (this.isMobileSso) {
                    try {
                        this.sendNativeCommand('samlReceived', samlCookie);
                        return;
                    } catch (ex) {
                        // do nothing, might not be using Sway app
                    }
                    return;
                }

                console.log('NewLogin - triggering SAML auto-login');
                this.isLoading = true;
                httpService.setAuthTokenHeader(samlCookie);
                this.extraLoginSaml();
                return;
            }
            this.isLoading = false;
        }
        catch (ex){
            console.log('NewLogin - SAML check error:', ex);
            this.isLoading = false;
        }
        console.log('NewLogin - beforeMount complete, isLoading:', this.isLoading);
    },
    mounted() {
        // Enable submit after component is mounted to prevent spurious auto-submit
        this.$nextTick(() => {
            this.allowSubmit = true;
            console.log('NewLogin mounted - allowSubmit enabled');
        });
    },
    computed: {
        samlUrl() {
            return baseUrl + "/saml/InitiateSingleSignOn?returnurl=" + this.returnUrl + "&email=" + encodeURIComponent(this.email);
            //return 'https://localhost:5001/api/saml/InitiateSingleSignOn?returnurl=' + this.returnUrl;
        },
        returnUrl() {
            let inputUrl = new URL(window.location.href);
            let inputParams = inputUrl.searchParams;
            if (!inputParams.has('isCallback'))
                inputParams.append('isCallback', 'true');
            if (!inputParams.has('email')) // HACK: SOMETIMES MOBILE POPULATES THIS
                inputParams.append('email', this.email);
            inputUrl.search = inputParams.toString();
            return encodeURIComponent(inputUrl.toString());
        }
    },
    watch: {
        
    },
    methods: {
        onEnter() {
            if (!this.allowSubmit) {
                console.log('onEnter blocked - allowSubmit is false');
                return;
            }
            this.onSubmit()
        },
        async onSubmit(event) {
            console.log('onSubmit called, email:', this.email);
            console.log('onSubmit event:', event);
            console.log('onSubmit allowSubmit:', this.allowSubmit);
            console.log('onSubmit stack trace:', new Error().stack);

            // Block submit if not allowed yet
            if (!this.allowSubmit) {
                console.log('onSubmit blocked - not allowed yet');
                return;
            }

            if (!this.email)
                return;
            
            this.loading = true;
            if (this.isPreLoginShowing){
                const response = await getloginmethod(this.email);
                console.log('GetLoginMethod response:', response);

                if (!response || !response.isSuccess) {
                    console.log('GetLoginMethod failed or no response');
                    this.loading = false;
                    this.failedLogin = true;
                    return;
                }

                this.loading = false;
                this.isPreLoginShowing = false;
                console.log('authenticationSource:', response.authenticationSource);
                console.log('allowSwayUsernamePassword:', response.allowSwayUsernamePassword);

                if (response.authenticationSource == 1){ // sway username password
                    console.log('Setting up password login');
                    this.isPasswordShowing = true;
                    this.showOAuthLoginLink = false;
                    this.showSamlLoginLink = false;
                    this.isPasswordOptionShowing = false;
                }
                else if (response.authenticationSource == 2){ // oauth
                    console.log('Setting up OAuth login');
                    this.titleText = "SSO Login";
                    this.isPasswordShowing = false;
                    this.showOAuthLoginLink = true;
                    this.showSamlLoginLink = false;
                    this.isPasswordOptionShowing = response.allowSwayUsernamePassword;
                }
                else if (response.authenticationSource == 3){ // saml
                    console.log('Setting up SAML login');
                    this.titleText = "SSO Login";
                    this.isPasswordShowing = false;
                    this.showOAuthLoginLink = false;
                    this.showSamlLoginLink = true;
                    this.isPasswordOptionShowing = response.allowSwayUsernamePassword;
                }
                console.log('Final state - showSamlLoginLink:', this.showSamlLoginLink, 'isPasswordOptionShowing:', this.isPasswordOptionShowing);
                
                this.isLoading = false;
            }
            else{
                const response = await login(this.email, this.password);
                await this.onLoginResponse(response);
            }
        },
        async backToPreLogin(){
            if (this.isMobileSso){
                this.sendNativeCommand('cancelLogin');
                return;
            }
            this.showOAuthLoginLink = false;
            this.showSamlLoginLink = false;
            this.isPasswordShowing = false;
            this.isPasswordOptionShowing = false;
            this.isPreLoginShowing = true;
            this.email = null;
            this.titleText = 'Login';
            this.isLoading = false;
        },
        async forgotPassword(){
            await this.$router.push('forgot-password');
        },
        async onLoginResponse(response) {
            console.log('onLoginResponse called:', response);
            if (!response || !response.isSuccess) {
                console.log('Login failed or no response');
                this.loading = false;
                this.failedLogin = true
                return;
            }
            const {account, hasMultipleOrganizations, availableOrganizations,selectedOrganization, mfaIsRequired} = response;
            console.log('mfaIsRequired:', mfaIsRequired);
            account.availableOrganizations = availableOrganizations;
            account.selectedOrganization = selectedOrganization
            this.setAccount(account);

            if (mfaIsRequired) {
                console.log('Opening MFA dialog');
                this.mfaVerificationDialog = true;
                console.log('mfaVerificationDialog set to:', this.mfaVerificationDialog);
                this.loading = false;
                // await this.$router.push({name: 'MultiFactorAuthentication', query: { redirect: this.$route.query.redirect ? this.$route.query.redirect : '/'}})
            } else {
                await this.finishLogin({account, hasMultipleOrganizations})
                this.isLoading = false;
            }

            // axios.post("/api/account/login", {'email': this.email, 'password': this.password}).then((response) => {
            //     console.log(response);
            // })
        },
        async finishLogin({account, hasMultipleOrganizations, selectedOrganization}) {
            // Identify the visitor + account in Pendo now that we know they're in a
            // fully-authenticated state. saveStuffFromLogin has already committed the
            // selected org to the store, so prefer that as the canonical source.
            const orgForPendo = this.$store.state.currentOrganization
                || selectedOrganization
                || account?.selectedOrganization;
            initializePendo(account, orgForPendo);

            let redirectOrgId = this.$route.query.orgId;
            
            // if (redirectString){
            //     let decodedRedirectString = fullyDecodeURI(redirectString);
            //    
            // }
            
            var redirectString = this.$route.query.redirect;
            if (redirectString) {
                
                //if there are multiple redirect strings, we need to get the last one
                if (Array.isArray(redirectString)) {
                    redirectString = redirectString[redirectString.length - 1]
                }
                
                if (redirectString.toLowerCase().includes('login') || redirectString.toLowerCase().includes('reset-password')) {
                    redirectString = '/'
                }
            }

            let {profileAccessLink} = this.$route.query;
            
            if (profileAccessLink){
                this.setAccount(account);
                
                await this.$router.push('/redeem-profile-access-link?orgSelected=false&profileAccessLink=' + profileAccessLink)
            } else if (redirectOrgId){
                const {account} = await switchSelectedOrganization(redirectOrgId);

                this.setAccount(account);

                await this.$router.push(redirectString ? redirectString : '/')
            } else if (hasMultipleOrganizations) {
                let temp = {name: 'SelectOrganization', query: { redirect: redirectString ? redirectString : '/', orgId: selectedOrganization ? selectedOrganization.id : null}}
                await this.$router.push(temp)
            } else if (account.accountTypeId === 4) {
                await this.$router.push('/account')
            } else {
                await this.$router.push(redirectString ? redirectString : '/')
            }
            this.loading = false;
        },
        loginWithSso() {
            const request = this.forceAccountSelect
                ? { ...loginRequest, prompt: 'select_account' }
                : loginRequest;
            auth.loginRedirect(request);
        },
        getTokenSso(autoRedirectOnFailure = false) {
            let _this = this;
            return auth.acquireTokenSilent(tokenConfig)
                    .catch(() => {
                        if (autoRedirectOnFailure) {
                            return auth.acquireTokenRedirect(tokenConfig);
                        }
                        // Don't auto-redirect, return null to show login options
                        return null;
                    })
                    .then(( token ) => token);
        },
        async extraLoginOauth() {
            var response = await ssologin(this.ssoToken);
            if (response.isSuccess)
                await this.onLoginResponse(response);
        },
        async extraLoginSaml() {
            var response = await samllogin();
            try{
                await this.onLoginResponse(response);
            }
            catch(e){
                await this.backToPreLogin();
            }
        },
        setAccount(account){
            this.$emit('setAccount', account)
        },
        showPasswordLogin(){
            if (this.isMobileSso){
                this.sendNativeCommand('loginWithPassword');
                return;
            }
            this.isPasswordShowing = true;
            this.isPasswordOptionShowing = false;
        },
        loginWithSaml(){
            if (this.isSamlLinkPressed)
                return; // prevent duplicate clicks
            
            this.isSamlLinkPressed = true;
            window.location.href = this.samlUrl;
        },
        sendNativeCommand(command, payload){
            if (this.mobileAppVersion && semver.gte(this.mobileAppVersion, '5.6.0')){
                funcs.sendNativeCommandMaui(command, payload);
            }
            else {
                funcs.sendNativeCommand(command, payload);
            }
        },
        useDifferentAccount(){
            // Clear SSO state and show normal login form
            this.isAutoSsoLogin = false;
            this.autoSsoEmail = null;
            this.ssoAccount = null;
            this.ssoToken = null;
            this.isLoading = false;
            this.isPreLoginShowing = true;
            this.titleText = 'Login';
            this.forceAccountSelect = true;
        }
    }
}
</script>

<style scoped>

.login {
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    align-items: center;
    background-color: white;
    height: 100vh
}

.login-input {
    width: 300px
}

.login-form-container {
    display: flex; flex-direction: column; align-items: center; flex: 2
}

.hover {
    cursor: pointer
}

</style>